import React, { useEffect, useState } from "react";
import styles from "./SeriesDetails.module.css";
import { Link, Route, Routes, useParams } from "react-router-dom";
import AllMatchesList from "../../components/AllMatchesList/AllMatchesList";
import LiveMatchesList from "../../components/LiveMatchesList/LiveMatchesList";
import UpcomingMatchesList from "../../components/UpcomingMatchesList/UpcomingMatchesList";
import RecentMatchesList from "../../components/RecentMatchesList/RecentMatchesList";
import { useDispatch, useSelector } from "react-redux";
import { homeData } from "../../features/home/homeSlice";
import { newsData } from "../../features/news/newSlice";
import PointsTable from "../../components/PointsTable/PointsTable";
import { seriesDetailsData } from "../../features/seriesDetails/seriesDetailsSlice";

const SeriesDetails = () => {
  const [pointsTable, setpointsTable] = useState(true);
  const [recentematch, setrecentmatch] = useState(false);
  const [upcoming, setupcoming] = useState(false);
  const { series_id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.seriesDetails.data);
  const pending = useSelector((state) => state.seriesDetails.pending);
  const error = useSelector((state) => state.seriesDetails.error);
  const finalData = data.data;

  // useEffect(() => {
  //   dispatch(seriesDetailsData(series_id));
  // }, [dispatch, series_id]);

  if (pending) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleClick = (name) => {
    switch (name) {
      case "points":
        setpointsTable(true);
        setrecentmatch(false);
        setupcoming(false);

        break;
      case "up":
        setpointsTable(false);
        setrecentmatch(false);
        setupcoming(true);

        break;

      case "recent":
        setpointsTable(false);
        setrecentmatch(true);
        setupcoming(false);

        break;
      default:
        setpointsTable(false);
        setrecentmatch(false);
        setupcoming(true);
    }
  };
  return (
    <div className={styles.parentContainer}>
      <div className={styles.fixturesHeading}>
        <h3>SERIES</h3>
      </div>

      <div className={styles.fixturesNavigation}>
        <ul className={styles.fixturesNavigationLinks}>
          <button
            onClick={() => handleClick("up")}
            className={` ${
              upcoming === true ? styles.active : styles.inactive
            } ${styles.fixtureStatus} `}
          >
            Upcoming Matches
          </button>
          <button
            onClick={() => handleClick("recent")}
            className={` ${
              recentematch === true ? styles.active : styles.inactive
            } ${styles.fixtureStatus} `}
          >
            Recent Matches
          </button>
          <button
            onClick={() => handleClick("points")}
            className={` ${
              pointsTable === true ? styles.active : styles.inactive
            } ${styles.fixtureStatus} `}
          >
            Points Table
          </button>
        </ul>
      </div>

      <div className={styles.fixtureCardsContainer}>
        {pointsTable && <PointsTable series_id={series_id} />}
        {recentematch && <RecentMatchesList series_id={series_id} />}
        {upcoming && <UpcomingMatchesList series_id={series_id} />}
      </div>
    </div>
  );
};

export default SeriesDetails;
